import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ActivityButton.css";
import Icon from "../Icon/Icon";

class ActivityButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const positionClass =
      this.props.position === "right"
        ? "activity-button--position-right"
        : "activity-button--position-left";
    return (
      <div className={"activity-button " + positionClass}>
        <div className="activity-button__icon">
          <img onClick={this.handleShow} src={this.props.icon} />
        </div>
        <div className="activity-button__content">{this.props.children}</div>
      </div>
    );
  }
}

ActivityButton.defaultProps = {
  icon: "",
  position: "left"
};

ActivityButton.propTypes = {
  /** The icon name to be rendered. */
  icon: PropTypes.string,
  /** The position of the icon (left or right). */
  position: PropTypes.oneOf(["left", "right"]),
  /** Required. The objects that will be rendered beside the icon. */
  children: PropTypes.element.isRequired
};

export default ActivityButton;



// WEBPACK FOOTER //
// ./src/components/UI/ActivityButton/ActivityButton.js